import React from "react";
import { EMPTY_USER_PERMISSIONS } from "../utils/userAccess";

const PERMISSION_ITEMS = [
    {
        key: "canCreateEmail",
        icon: "bi-envelope-plus",
        title: "Create Email Accounts",
        desc: "Add new inbox accounts (receive & send)",
    },
    {
        key: "canUseEmailSender",
        icon: "bi-send-check",
        title: "Email Sender",
        desc: "Bulk & single email campaigns from sidebar",
    },
    {
        key: "canUseEmailValidator",
        icon: "bi-shield-check",
        title: "Email Validator",
        desc: "Validate CSV email lists professionally",
    },
    {
        key: "canManageFollowUps",
        icon: "bi-journal-check",
        title: "Follow-Up Sheet",
        desc: "Personal follow-up records (name, email, notes)",
    },
    {
        key: "canEditEmailTemplates",
        icon: "bi-file-earmark-richtext",
        title: "Edit Email Templates",
        desc: "Edit templates inside Email Sender",
    },
    {
        key: "canSendSms",
        icon: "bi-chat-dots",
        title: "Send SMS",
        desc: "Send single & bulk SMS via Twilio",
    },
    {
        key: "canReceiveSms",
        icon: "bi-chat-left-text",
        title: "Receive SMS",
        desc: "View incoming SMS messages in CRM inbox",
    },
    {
        key: "canEditSmsTemplates",
        icon: "bi-file-earmark-text",
        title: "Edit SMS Templates",
        desc: "Create and edit SMS templates for bulk send",
    },
];

export default function UserPermissionsPanel({ permissions, onChange, disabled }) {
    const perms = permissions || EMPTY_USER_PERMISSIONS;

    const toggle = (key) => {
        if (disabled) return;
        onChange({ ...perms, [key]: !perms[key] });
    };

    return (
        <div className="crm-permissions-panel">
            <div className="crm-permissions-panel-header">
                <h5><i className="bi bi-sliders me-2"></i>Feature Permissions</h5>
                <p>Select which tools this user can access beyond country permissions.</p>
            </div>
            <div className="crm-permissions-grid">
                {PERMISSION_ITEMS.map((item) => (
                    <label
                        key={item.key}
                        className={`crm-permission-card ${perms[item.key] ? "crm-permission-card--active" : ""}`}
                    >
                        <input
                            type="checkbox"
                            checked={!!perms[item.key]}
                            onChange={() => toggle(item.key)}
                            disabled={disabled}
                        />
                        <div className="crm-permission-card-icon">
                            <i className={`bi ${item.icon}`}></i>
                        </div>
                        <div className="crm-permission-card-body">
                            <strong>{item.title}</strong>
                            <span>{item.desc}</span>
                        </div>
                        <div className="crm-permission-card-check">
                            <i className={`bi ${perms[item.key] ? "bi-check-circle-fill" : "bi-circle"}`}></i>
                        </div>
                    </label>
                ))}
            </div>
        </div>
    );
}
